import DisclaimerContainer from './DisclaimerContainer';

export default DisclaimerContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/Disclaimer/index.js